import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template 10 - Number of policies by whether one of the Policy Holders is the Insured Person"
	],
	[
		"",
		"Number of Policy Holders",
		"Number of Standard Plan Policies",
		"Number of Flexi Plan Policies"
	]
]
const rows = payload => {
	let output = []
	for (let i = 1; i <= 20; i++) {
		if (i >= 11) {
			output.push([
				"No Policy Holder is the insured Person",
				i - 10,
				checkIfNoHolderIsInsured(payload, i - 10, "S00027"),
				checkIfNoHolderIsInsured(payload, i - 10, "F00038")
			])
		} else {
			output.push([
				"At least one Policy Holder is insured person",
				i,
				checkIfOneHolderIsInsured(payload, i, "S00027"),
				checkIfOneHolderIsInsured(payload, i, "F00038")
			])
		}
	}
	return output
}

/**
 * @description
 * returns count of Policy Holders that are not the Insured Person
 * @param {*} payload
 * @param {*} numberOfPolicyHolders
 */

const checkIfOneHolderIsInsured = (payload, numberOfPolicyHolders, plan) => {
	return payload.filter(policy => {
		// Name of Primary Holder
		const holderName = policy?.contractHolder?.name
		// Name of Insured Person
		const insuredName = policy?.contractInsured?.[0]?.name
		// Array of Other Holders
		const otherHoldersArray = policy?.otherContractHolders
		// Array of Primary Holder Name and Other Holders Names
		let allHolderNamesArray = [holderName]
		if (otherHoldersArray) {
			allHolderNamesArray.push(otherHoldersArray?.map(item => item.name))
		}

		// Sum of Other holder(s) + Primary Holder
		const totalPolicyHolders =
			otherHoldersArray !== null ? otherHoldersArray.length + 1 : 0

		// Check whether one of Policy holders is Insured Person
		let hasEqual = null
		allHolderNamesArray.filter(item => {
			if (insuredName === item) hasEqual = true
		})

		let matchPlan = policy?.product?.productId?.plan?.includes(plan)

		if (
			policy.status === "ISSUED" &&
			totalPolicyHolders === numberOfPolicyHolders &&
			hasEqual === true &&
			matchPlan
		) {
			return policy
		}
	}).length
}
const checkIfNoHolderIsInsured = (payload, numberOfPolicyHolders, plan) => {
	return payload.filter(policy => {
		// Name of Primary Holder
		const holderName = policy?.contractHolder?.name
		// Name of Insured Person
		const insuredName = policy?.contractInsured?.[0]?.name
		// Array of Other Holders
		const otherHoldersArray = policy?.otherContractHolders
		// Array of Primary Holder Name and Other Holders Names
		let allHolderNamesArray = [holderName]
		if (otherHoldersArray) {
			allHolderNamesArray.push(otherHoldersArray?.map(item => item.name))
		}

		// Sum of Other holder(s) + Primary Holder
		const totalPolicyHolders =
			otherHoldersArray !== null ? otherHoldersArray.length + 1 : 0

		// Check whether one of Policy holders is Insured Person
		let noEqual = null
		allHolderNamesArray.filter(item => {
			if (insuredName !== item) noEqual = true
		})

		let matchPlan = policy?.product?.productId?.plan?.includes(plan)

		if (
			policy.status === "ISSUED" &&
			totalPolicyHolders === numberOfPolicyHolders &&
			noEqual === true &&
			matchPlan
		) {
			return policy
		}
	}).length
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate10Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					product {
						productId {
							plan
						}
					}
					contractInsured {
						... on individual {
							name
						}
					}
					contractHolder {
						... on individual {
							name
						}
					}
					otherContractHolders {
						... on individual {
							name
						}
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[1].map(item => {
		return { wpx: 200 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 2, c: 0 },
			e: { r: 11, c: 0 }
		},
		{
			s: { r: 12, c: 0 },
			e: { r: 21, c: 0 }
		}
	]

	return { workSheetData, workSheetColumns, workSheetMerges }
}
